<form [formGroup]="form">
  <div class="form-section">
    <div formArrayName="involvedVehicles">
      @for (vehicleControl of involvedVehiclesArray.controls; track $index; let i = $index) {
      <div class="vehicle-block" [formGroupName]="i">
        <div class="vehicle-row">
          <mat-form-field appearance="outline" class="plate-field">
            <mat-label>{{ 'field.involvedVehiclePlate' | translate }}</mat-label>
            <input matInput
                   formControlName="plate"
                   [placeholder]="'placeholder.involvedVehiclePlate' | translate"
                   (input)="onPlateChange(i, $event)">
            @if (getPlateControl(i)?.hasError('required')) {
              <mat-error>{{ 'error.targa.required' | translate }}</mat-error>
            }
            @if (getPlateControl(i)?.hasError('pattern')) {
              <mat-error>{{ 'error.targa.pattern' | translate }}</mat-error>
            }
          </mat-form-field>

          <button mat-icon-button
                  type="button"
                  color="primary"
                  [disabled]="!canShowAddButton(i)"
                  (click)="addVehicle()">
            <mat-icon>add</mat-icon>
          </button>

          @if (canShowDeleteButton(i)) {
            <button mat-icon-button
                    type="button"
                    color="warn"
                    (click)="removeVehicle(i)">
              <mat-icon>delete</mat-icon>
            </button>
          }
        </div>

        <div class="counterparty-section">
          <h4>{{ 'section.counterparty' | translate }}</h4>
          <div class="counterparty-fields">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'field.nome' | translate }}</mat-label>
              <input matInput formControlName="nome">
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>{{ 'field.cognome' | translate }}</mat-label>
              <input matInput formControlName="cognome">
            </mat-form-field>

            <mat-form-field appearance="outline" class="address-field">
              <mat-label>{{ 'field.indirizzoResidenza' | translate }}</mat-label>
              <input matInput formControlName="indirizzo">
            </mat-form-field>

            <app-international-phone-input
              formControlName="telefono"
              [required]="false"
              (validationChange)="onPhoneValidation(i, $event)"
              [hasError]="!isPhoneValid(i)">
            </app-international-phone-input>
          </div>
        </div>
      </div>
      }
    </div>
    @if (hasDuplicates()) {
      <div class="duplicate-error">
        <mat-icon>error</mat-icon>
        <span>{{ 'error.duplicatePlates' | translate }}</span>
      </div>
    }
    <div class="confirm-section">
      <button mat-raised-button
              type="button"
              color="primary"
              class="confirm-btn"
              [disabled]="!hasValidPlates() || hasDuplicates()"
              (click)="confirmVehicles()">
        <mat-icon>check_circle</mat-icon>
        {{ 'button.addVehicles' | translate }}
      </button>
    </div>
  </div>
</form>
